export default __webpack_public_path__ + "static/media/pioneer-10.1c495599.png";